export const BASE_URL = {
        // URL: 'http://127.0.0.1:8000/api/v1',
        // URL: 'http://54.73.58.228:100/api/v1',
        URL: 'https://api.itraksys.com/api/v1',
        APP_URL: 'http://itracsys.kamamedical.ie/assets/ProductImages/',
        PRINTER_APP_URL: 'https://itracsyslocalhost.com:8787/',
}
export const N_MODULE = {
        Sale_Order_Notification: 8,
        Sale_Invoice_Notification: 11,
        Sale_Reorder_Notification: 12,
        Implants_Consumed_Notification: 13,
        Implants_Rejected_Notification: 14,
        Implants_Movement_Notification: 10
}

